var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs-center link",on:{"click":function($event){$event.stopPropagation();return _vm.navPage('/Dokumente/Archiv')}}},[_vm._v(" "+_vm._s(_vm.aktuellesNote[0]['value'])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }